import React from 'react';
import { Box, useMediaQuery, useTheme } from '@ublend-npm/aulaui-core';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { viewportHeightWithOffset } from '@app/utils/viewportHeight';
import MessageListAndToolsContainer from './MessageListAndTools/MessageListAndToolsContainer';

// Conversation view: fetches by params.id and displays messages (no modals)
const ConversationsContainer = ({ route }: any) => {
  const { palette, breakpoints } = useTheme();
  const isDesktop = useMediaQuery(breakpoints.up('md'));
  const ConverstaionMenu = route?.conversationsMenu;
  const { webAppFtResponsiveMessages202506 } = useFlags();
  const desktopHeight = viewportHeightWithOffset(65);
  const mobileHeight = viewportHeightWithOffset(61);
  return (
    webAppFtResponsiveMessages202506 && (
      <Box
        width="100%"
        height={isDesktop ? desktopHeight : mobileHeight}
        display="flex"
        bgcolor={palette.background.default}
      >
        <Box>{isDesktop && <ConverstaionMenu />}</Box>
        <Box
          sx={{
            width: '100%',
            p: isDesktop ? '24px' : '8px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            id="sudo-vodo"
            width={{ xs: '100%', sm: '100%', md: '100%', lg: '80%' }}
            sx={{
              margin: 'auto',
              display: 'flex',
              height: '86vh',
              flexDirection: 'column',
            }}
          >
            <Box
              tabIndex={0}
              bgcolor={palette.background.paper}
              width="100%"
              borderRadius="8px"
              height="100%"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: 0,
              }}
            >
              <MessageListAndToolsContainer />
            </Box>
          </Box>
        </Box>
      </Box>
    )
  );
};

export default ConversationsContainer;
